/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import classNames from 'classnames'
import TextField from '@material-ui/core/TextField'
import { openPaymentsModal } from 'actions/paymentsManager'
import { toggleDialog, toggleState } from 'actions/users'
import {
  listPreferences,
  putPreferences,
  listSettings,
  putSettings,
} from '../../actions/AccountSettings.js'
import { read, create, update } from 'actions/data'
import Tooltip2 from '@material-ui/core/Tooltip'
import Tooltip from 'components/theme/HelpTooltip.js'
import DoneIcon from '@material-ui/icons/Done'
import Button from 'components/theme/Button'
import Paper from 'components/theme/Paper'
import Grid from '@material-ui/core/Grid'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import AttachMoney from '@material-ui/icons/AttachMoney'
import { Palette, AccountRemove } from 'mdi-material-ui'
import DataUsageIcon from '@material-ui/icons/DataUsage'
// import BadgeIcon from '../theme/BadgeIcon.js';
import Settings from '@material-ui/icons/Settings'
import Person from '@material-ui/icons/Person'
import Phone from '@material-ui/icons/Phone'
import Contacts from '@material-ui/icons/Contacts'
import language from 'utils/vast-languagepack'
import Select from 'react-select'
import states from './states.js'
import states_map from './states_map.js'
import provinces from './provinces'
import provinces_map from './provinces_map'
import { toggleManagePhonesModal } from 'actions/tasks'
import { ArrowDropDown } from '@material-ui/icons'
import {
  withStyles,
  Menu,
  MenuItem,
  withMobileDialog,
  FormControl,
  OutlinedInput,
  Select as MaterialSelect,
} from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import AdditionalUsage from '../AdditionalUsage'
import { themeObj } from 'components/withRoot'
import EmailSelect from './EmailSelect'
import { toggleDialog as toggleRoundRobinDialog } from 'actions/roundRobin'
import { toggleDialog as toggleLogoDialog } from 'actions/logoManagementAndBranding'
import { openDeletePersonalDataDialog } from 'actions/view'
import US from 'utils/flags/US.png'
import CA from 'utils/flags/CA.png'

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

const mapStateToProps = state => {
  const vr_account_id =
    state.auth?.session?.idToken?.payload?.['custom:vr_account_id']
  const cognitoUsername =
    state?.auth?.session?.idToken?.payload?.['cognito:username']

  return {
    ...state.AccountSettings,
    verify_default_address_status:
      state.data['email/verify_default_address_status'],
    vr_role: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
    cognitoUsername:
      state?.auth?.session?.idToken?.payload?.['cognito:username'],
    phoneNumbersAllowed:
      state.data?.screenpermissions?.[
        `screenpermissions-${cognitoUsername}-${vr_account_id}`
      ]?.permissions?.phones,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      listPreferences,
      putPreferences,
      listSettings,
      putSettings,
      openPaymentsModal,
      read,
      create,
      update,
      toggleDialog,
      toggleState,
      toggleManagePhonesModal,
      toggleRoundRobinDialog,
      toggleLogoDialog,
      openDeletePersonalDataDialog,
    },
    dispatch,
  )

const customStyles = {
  control: provided => ({
    ...provided,
    borderRadius: '4px',
    padding: '9px 0',
    cursor: 'pointer',
  }),
  menu: provided => ({
    ...provided,
    zIndex: 2,
  }),
  multiValue: provided => ({
    ...provided,
    backgroundColor: themeObj.palette.secondary.main,
    borderRadius: 15,
    padding: 4,
  }),
  multiValueLabel: provided => ({
    ...provided,
    color: '#fff',
  }),
  multiValueRemove: provided => ({
    ...provided,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    marginLeft: 4,
    ':hover': {
      backgroundColor: '#fff',
    },
  }),
}

const styles = theme => ({
  content: {
    padding: 24,
    [theme.breakpoints.down('sm')]: {
      // padding: maybe something else for 'sm' size,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  h2: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  h1: {
    color: theme.palette.secondary.main,
  },
  samesasbutton: {
    margin: theme.spacing.unit,
    fontSize: 10,
  },
  p: {
    fontSize: 14,
    marginLeft: theme.spacing.unit,
  },
  paper: {
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 4,
    paddingTop: theme.spacing.unit / 2,
    paddingBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    border: '#adadad solid 1px',
    position: 'relative',
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  // paperFullWidth: { height: '100%' },
  rounded: {
    borderRadius: 28,
    // overflowY: 'hidden',
    // height: '100%',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      // overflowY: 'auto',
    },
  },
  dialogContentRoot: {
    padding: 0,
    '&:first-child': { paddingTop: 0 },
  },
  dialogActionsRoot: {
    margin: 0,
    padding: '8px 4px',
    borderTop: '1px solid #808080',
  },
  sideButton: {
    height: '36.5px',
    // [theme.breakpoints.down('sm')]: {
    //   height: 32,
    // },
  },
})
class AccountSettingsPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      saved: false,
      preferences: {},
      settings: {
        mailing: {},
        billing: {},
        business_name: '',
        anchorEl: null,
      },
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSettingsChange = this.handleSettingsChange.bind(this)
    this.clickSameMailing = this.clickSameMailing.bind(this)
    this.clickSameBilling = this.clickSameBilling.bind(this)
  }

  componentDidMount() {
    this.props.read('', 'account/preference', null, 'none').then(prefs => {
      if (prefs.preferences) {
        this.setState({ preferences: prefs.preferences })

        if (prefs.preferences.default_email_from) {
          this.props.read(
            '',
            'email/verify_default_address_status',
            null,
            'none',
          )
        }
      }
    })

    this.props.read('', 'account', null, 'none').then(settings => {
      this.setState({ settings })
    })
  }

  handleChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState({
      ...this.state,
      preferences: {
        ...this.state.preferences,
        [name]: value,
      },
    })
  }

  handleStateChange = selectedOption => {
    // console.log(selectedOption)
    this.setState({
      ...this.state,
      settings: {
        ...this.state.settings,
        mailing: {
          ...this.state.settings.mailing,
          // country: 'US',
          state_province: selectedOption.value,
        },
      },
    })
  }

  handleCountryChange = country => {
    this.setState({
      ...this.state,
      settings: {
        ...this.state.settings,
        mailing: {
          ...this.state.settings.mailing,
          country,
        },
      },
    })
  }

  handleSettingsChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const baseproperty = target.attributes.baseproperty
      ? target.attributes.baseproperty.value
      : undefined
    const name = target.name

    if (baseproperty) {
      this.setState({
        ...this.state,
        settings: {
          ...this.state.settings,
          [baseproperty]: {
            ...this.state.settings[baseproperty],
            [name]: value,
          },
        },
      })
    } else {
      this.setState({
        ...this.state,
        settings: {
          ...this.state.settings,
          [name]: value,
        },
      })
    }
  }

  clickSameMailing() {
    this.setState({
      ...this.state,
      settings: {
        ...this.state.settings,
        billing: this.state.settings.mailing,
      },
    })
  }

  clickSameBilling() {
    this.setState({
      ...this.state,
      settings: {
        ...this.state.settings,
        mailing: this.state.settings.billing,
      },
    })
  }

  handleSubmit() {
    const { preferences, settings } = this.state

    // this.props
    //   .putPreferences({
    //     account_id: this.state.settings.id,
    //     preferences,
    //   })
    //   .then(() => {
    //     this.setState({
    //       ...this.state,
    //       saved: true,
    //     })
    //   })

    // this.props.putSettings(settings).then(() => {
    //   this.setState({
    //     ...this.state,
    //     saved: true,
    //   })
    // })

    this.props
      .update(
        {
          account_id: this.state.settings.id,
          preferences,
        },
        'account/preference',
        '',
        'account/preference',
        'none',
      )
      .then(payload => {
        if (
          jwtToken &&
          window?.ReactNativeWebView?.postMessage &&
          payload?.preferences?.company_logo_url_color
        ) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              storeProfile: {
                username: this.props.cognitoUsername,
                company_logo_url_color:
                  payload.preferences.company_logo_url_color,
              },
            }),
          )
        }
      })

    this.props
      .update(settings, 'account', '', 'account', 'none')
      .then(payload => {
        if (
          jwtToken &&
          window?.ReactNativeWebView?.postMessage &&
          payload?.business_name
        ) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              storeProfile: {
                username: this.props.cognitoUsername,
                business_name: payload.business_name,
              },
            }),
          )
        }
      })

    if (
      preferences.default_email_from !==
      this.props.preferences.preferences.default_email_from
    ) {
      this.props.create({
        entity: { account_id: this.props.settings.id },
        entityType: 'email/verify_default_address_status',
        path: 'email/verify_default_address',
        noReturnValue: true,
      })
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  openAdditionalUsageModal = show => {
    this.setState({
      ...this.state,
      additionalUsageModalOpen: show,
    })
  }

  openPersonalDataModal = show => {
    this.setState({
      ...this.state,
      openPersonalDataModalOpen: show,
    })
  }

  render() {
    const {
      classes,
      // error,
      openPaymentsModal,
      verify_default_address_status,
      toggleDialog,
      vr_role,
      toggleState,
      fullScreen,
      toggleLogoDialog,
    } = this.props

    const { saved, preferences, settings, anchorEl } = this.state

    const status =
      verify_default_address_status && verify_default_address_status.status

    // if (error) {
    //   return (
    //     <h3>
    //       {language.accountSettings.notification.problem} {error.message}
    //     </h3>
    //   )
    // }

    return (
      <div className={this.props.classes.content}>
        <h1
          style={{
            marginLeft: 8,
            color: '#014c94',
            marginRight: 8,
            display: 'inline',
          }}
        >
          <Settings /> Account{' '}
          <Tooltip>
            <span>
              Enter your company or business name here, this will represent your
              business on email addresses.
            </span>
          </Tooltip>
        </h1>
        <div style={{ marginTop: 10, marginLeft: 10 }}>
          {!jwtToken && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => openPaymentsModal(true)}
              style={{ marginRight: 8, marginBottom: 8 }}
            >
              <AttachMoney style={{ marginRight: 5 }} />
              Subscription
            </Button>
          )}
          {vr_role === 'acctowner' && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => toggleLogoDialog(true)}
              style={{ marginRight: 8, marginBottom: 8 }}
            >
              <Palette style={{ marginRight: 5 }} />
              Personalize
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.openAdditionalUsageModal(true)}
            style={{ marginRight: 8, marginBottom: 8 }}
          >
            <DataUsageIcon style={{ marginRight: 5 }} />
            Usage Data
          </Button>
          <Dialog
            open={this.state.additionalUsageModalOpen}
            aria-labelledby="responsive-dialog-title"
            // style={{ borderRadius: 22 }}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="xl"
            PaperProps={{ classes: { rounded: classes.rounded } }}
            // classes={{ paperFullWidth: classes.paperFullWidth }}
          >
            <DialogContent classes={{ root: classes.dialogContentRoot }}>
              <AdditionalUsage
                // open={this.state.additionalUsageModalOpen}
                openAdditionalUsageModal={this.openAdditionalUsageModal}
              />
            </DialogContent>
            <DialogActions classes={{ root: classes.dialogActionsRoot }}>
              <Button
                onClick={() => {
                  this.openAdditionalUsageModal(false)
                }}
                color="secondary"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          {this.props.phoneNumbersAllowed === false ? null : (
            <Button
              style={{ marginRight: 8, marginBottom: 8 }}
              variant="contained"
              color="primary"
              onClick={() => this.props.toggleManagePhonesModal()}
            >
              <Phone style={{ marginRight: 5 }} />
              Phone Numbers
            </Button>
          )}
          <Dialog
            open={this.state.additionalUsageModalOpen}
            aria-labelledby="responsive-dialog-title"
            // style={{ borderRadius: 22 }}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="xl"
            PaperProps={{ classes: { rounded: classes.rounded } }}
            // classes={{ paperFullWidth: classes.paperFullWidth }}
          >
            <DialogContent classes={{ root: classes.dialogContentRoot }}>
              <AdditionalUsage
                // open={this.state.additionalUsageModalOpen}
                openAdditionalUsageModal={this.openAdditionalUsageModal}
              />
            </DialogContent>
            <DialogActions classes={{ root: classes.dialogActionsRoot }}>
              <Button
                onClick={() => {
                  this.openAdditionalUsageModal(false)
                }}
                color="secondary"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          {vr_role === 'acctowner' && (
            <Button
              style={{ marginRight: 8, marginBottom: 8 }}
              variant="contained"
              color="primary"
              onClick={() => this.props.toggleRoundRobinDialog()}
            >
              <Contacts style={{ marginRight: 5 }} />
              Contact Settings
            </Button>
          )}
          {vr_role === 'acctowner' ? (
            <div style={{ display: 'inline-flex', verticalAlign: 'sub' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  toggleState('users')
                  toggleDialog(true)
                }}
                style={{
                  marginBottom: 8,
                  borderTopLeftRadius: 35,
                  borderBottomLeftRadius: 35,
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
              >
                <Person style={{ marginRight: 5 }} />
                Users
              </Button>
              <Button
                className={classes.sideButton}
                aria-owns={
                  anchorEl ? 'user-invites-side-button-menu' : undefined
                }
                aria-haspopup="true"
                onClick={this.handleClick}
                variant="contained"
                color="primary"
                style={{
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderTopRightRadius: 35,
                  borderBottomRightRadius: 35,
                  padding: 6,
                  minWidth: 0,
                  marginBottom: 8,
                  marginRight: 8,
                }}
              >
                <ArrowDropDown />
              </Button>
              <Menu
                id="user-invites-side-button-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem
                  onClick={() => {
                    toggleState('invites')
                    toggleDialog(true)
                    this.handleClose()
                  }}
                >
                  User Invites
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    toggleState('assignmentPool')
                    toggleDialog(true)
                    this.handleClose()
                  }}
                >
                  Assignment Pool
                </MenuItem>
              </Menu>
            </div>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                toggleState('users')
                toggleDialog(true)
              }}
              style={{ marginBottom: 8, marginRight: 8 }}
            >
              <Person style={{ marginRight: 5 }} />
              Users
            </Button>
          )}
          <Button
            style={{ marginRight: 8, marginBottom: 8 }}
            variant="contained"
            color="primary"
            onClick={() => this.props.openDeletePersonalDataDialog(true)}
          >
            <AccountRemove style={{ marginRight: 5 }} />
            Delete personal data
          </Button>
        </div>
        <Paper className={classes.paper}>
          <div
            style={{ position: 'absolute', left: 16, top: 8, color: '#828282' }}
          >
            Account ID: {settings?.id}
          </div>
          {saved ? (
            <p style={{ color: 'green' }}>
              {language.accountSettings.notification.success}
            </p>
          ) : (
            ''
          )}

          <Grid style={{ marginTop: 5 }} container spacing={24}>
            <Grid item xs={12} sm={6}>
              <div>
                <h2>
                  {language.accountSettings.viewAll.businessName}{' '}
                  <Tooltip>
                    <span>
                      Enter your company or business name here, this will
                      represent your business on email addresses.
                    </span>
                  </Tooltip>
                </h2>
                <p className={classes.p}>
                  <em>{language.accountSettings.viewAll.belowEmails}</em>
                </p>
                <TextField
                  variant="outlined"
                  onChange={e =>
                    this.setState({
                      ...this.state,
                      settings: {
                        ...this.state.settings,
                        business_name: (e && e.target && e.target.value) || '',
                      },
                    })
                  }
                  name="business_name"
                  style={{ margin: 8, fontSize: 52 }}
                  placeholder={
                    language.accountSettings.helperText.businessPlaceHolder
                  }
                  fullWidth
                  value={settings.business_name}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <h2>Company Information </h2>
                <TextField
                  variant="outlined"
                  onChange={e => {
                    this.setState({
                      ...this.state,
                      preferences: {
                        ...this.state.preferences,
                        company_website: e.target.value,
                      },
                    })
                  }}
                  name="company_website"
                  label="Company Website"
                  style={{ margin: 8 }}
                  value={preferences?.company_website}
                  placeholder="example: https://www.yourcompany.com"
                  fullWidth
                  inputProps={{
                    baseproperty: 'company_website',
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  variant="outlined"
                  onChange={e => {
                    this.setState({
                      ...this.state,
                      preferences: {
                        ...this.state.preferences,
                        company_description: e.target.value,
                      },
                    })
                  }}
                  name="company_description"
                  label="Company Description"
                  multiline
                  rows="4"
                  style={{ margin: 8 }}
                  value={preferences?.company_description}
                  placeholder="Describe your company's mission, products, or services in a few sentences"
                  fullWidth
                  inputProps={{
                    baseproperty: 'company_description',
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <h2>
                  {language.accountSettings.viewAll.mailingAddress}{' '}
                  <Tooltip>
                    <span>
                      Enter your mailing address here, this will represent your
                      business addresses on emails. This is mandatory by law
                      under the CAN-SPAM ACT.
                    </span>
                  </Tooltip>
                </h2>
                <p>
                  <em>{language.accountSettings.viewAll.addressBelow}</em>
                </p>
                <div>
                  <div
                    style={{ position: 'relative', margin: '0 -8px 4px 8px' }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        fontSize: 12,
                        color: 'rgba(0, 0, 0, 0.56)',
                        top: -6,
                        left: 11,
                        backgroundColor: '#fff',
                        zIndex: 2,
                        textAlign: 'center',
                        padding: '0 5px',
                      }}
                    >
                      Country
                    </div>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <MaterialSelect
                        value={settings?.mailing?.country || 'US'}
                        onChange={e =>
                          this.handleCountryChange(e?.target?.value)
                        }
                        input={
                          <OutlinedInput
                            name="country"
                            id="outlined-country-simple"
                          />
                        }
                      >
                        <MenuItem value="US">
                          <img
                            src={US}
                            alt="US"
                            style={{
                              marginRight: 5,
                              width: 25,
                              verticalAlign: 'middle',
                            }}
                          />
                          US
                        </MenuItem>
                        <MenuItem value="CA">
                          <img
                            src={CA}
                            alt="CA"
                            style={{
                              marginRight: 5,
                              width: 25,
                              verticalAlign: 'middle',
                            }}
                          />
                          CA
                        </MenuItem>
                      </MaterialSelect>
                    </FormControl>
                  </div>
                  <TextField
                    variant="outlined"
                    onChange={this.handleSettingsChange}
                    name="address_line_1"
                    label={language.accountSettings.labels.addressLabel}
                    style={{ margin: 8 }}
                    value={
                      settings.mailing ? settings.mailing.address_line_1 : ''
                    }
                    placeholder={
                      language.accountSettings.helperText.addressPlaceHolder
                    }
                    fullWidth
                    inputProps={{
                      baseproperty: 'mailing',
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    variant="outlined"
                    onChange={this.handleSettingsChange}
                    name="address_line_2"
                    label={language.accountSettings.labels.addressLabel2}
                    style={{ margin: 8 }}
                    placeholder={
                      language.accountSettings.helperText.addressPlaceHolder2
                    }
                    fullWidth
                    value={
                      settings.mailing ? settings.mailing.address_line_2 : ''
                    }
                    inputProps={{
                      baseproperty: 'mailing',
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    variant="outlined"
                    onChange={this.handleSettingsChange}
                    name="city"
                    fullWidth
                    label={language.accountSettings.labels.cityLabel}
                    style={{ margin: '8px 8px 15px' }}
                    placeholder={
                      language.accountSettings.helperText.cityPlaceHolder
                    }
                    value={settings.mailing ? settings.mailing.city : ''}
                    inputProps={{
                      baseproperty: 'mailing',
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />{' '}
                  <div style={{ position: 'relative' }}>
                    <div
                      style={{
                        position: 'absolute',
                        fontSize: 12,
                        color: 'rgba(0, 0, 0, 0.56)',
                        top: -6,
                        left: 17,
                        backgroundColor: '#fff',
                        zIndex: 2,
                        textAlign: 'center',
                        padding: '0 5px',
                      }}
                    >
                      {settings?.mailing?.country === 'CA'
                        ? 'Province / Territory'
                        : 'State / Territory'}
                    </div>
                    <div
                      style={{
                        display: 'block',
                        fontSize: '1rem',
                        marginLeft: 8,
                        marginRight: -8,
                        marginBottom: 8,
                      }}
                    >
                      <Select
                        value={
                          settings?.mailing?.country === 'CA'
                            ? {
                                label:
                                  provinces_map[
                                    settings?.mailing?.state_province
                                  ],
                                value: settings?.mailing?.state_province,
                              }
                            : {
                                label:
                                  states_map[settings?.mailing?.state_province],
                                value: settings?.mailing?.state_province,
                              }
                        }
                        styles={customStyles}
                        placeholder={
                          language.accountSettings.helperText.statePlaceHolder
                        }
                        onChange={this.handleStateChange}
                        options={
                          settings?.mailing?.country === 'CA'
                            ? provinces
                            : states
                        }
                      />
                    </div>
                  </div>
                  <TextField
                    fullWidth
                    variant="outlined"
                    onChange={this.handleSettingsChange}
                    name="zip"
                    label={language.accountSettings.labels.zipLabel}
                    style={{ margin: 8 }}
                    placeholder={
                      language.accountSettings.helperText.zipPlaceHolder
                    }
                    value={settings.mailing ? settings.mailing.zip : ''}
                    inputProps={{
                      baseproperty: 'mailing',
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <em
                    style={{
                      display: 'block',
                      fontSize: 10,
                      margin: '8px 8px 0px 8px',
                      color: '#AAAAAA',
                    }}
                  >
                    (Currently we only support businesses in the United States
                    and Canada)
                  </em>
                </div>
              </div>
              {/* <div
                class="vast_reach_custom_form"
                data-vast-form-id="029579ac-616e-402a-a234-8a632934b201"
              /> */}
            </Grid>
            <Grid item xs={12} sm={6}>
              <h2>
                {language.accountSettings.viewAll.defaultEmailAddress}{' '}
                <Tooltip>
                  <span>
                    This will be the email you will be using to send all your
                    emails from on this account. Please make sure to verify this
                    email by clicking the blue button below to send/resend the
                    email verification. You can check verification by checking
                    the <strong>Status:</strong> above the blue button. It will
                    move from{' '}
                    <strong style={{ color: '#d89300' }}>Pending</strong> to{' '}
                    <strong style={{ color: '#15b940' }}>Success</strong> once
                    it is verified.
                  </span>
                </Tooltip>
              </h2>
              <p className={classes.p}>
                <em>
                  {language.accountSettings.viewAll.allEmailsSent}
                  <strong>{preferences.default_email_from}</strong>
                </em>
              </p>
              <TextField
                variant="outlined"
                onChange={this.handleChange}
                name="default_email_from"
                style={{ margin: 8 }}
                placeholder={
                  language.accountSettings.helperText.emailPlaceHolder
                }
                fullWidth
                value={preferences.default_email_from}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <p style={{ marginBottom: 5 }} className={classes.p}>
                Status:{' '}
                <em>
                  <strong
                    style={{
                      color: status === 'success' ? 'green' : 'orange',
                    }}
                  >
                    {status}
                  </strong>
                </em>
              </p>
              <div>
                <Button
                  color="primary"
                  variant="contained"
                  // disabled={
                  //   status === 'success' ||
                  //   status === 'pending' ||
                  //   preferences.default_email_from !==
                  //     this.props.preferences.default_email_from
                  // }
                  onClick={() => {
                    if (
                      preferences.default_email_from !==
                      this.props.preferences.preferences.default_email_from
                    ) {
                      this.props
                        .create({
                          entity: { account_id: this.props.settings.id },
                          entityType: 'email/verify_default_address_status',
                          path: 'email/verify_default_address',
                          noReturnValue: true,
                        })
                        .then(() => {
                          this.props.create({
                            entity: { account_id: this.props.settings.id },
                            entityType: 'email/verify_default_address_status',
                            path: 'email/verify_default_address',
                            noReturnValue: true,
                          })
                        })
                    }

                    this.props.create({
                      entity: { account_id: this.props.settings.id },
                      entityType: 'email/verify_default_address_status',
                      path: 'email/verify_default_address',
                      noReturnValue: true,
                    })
                  }}
                >
                  {status === 'success' || status === 'pending'
                    ? 'Re-send verification email'
                    : 'Send verification email'}
                </Button>
              </div>

              <h2>User Email Address</h2>
              <p className={classes.p}>
                <em>
                  You can use these addresses to send emails with Vast Reach.
                  Users can only verify their own email addresses.
                </em>
              </p>
              <div>
                <EmailSelect customStyles={customStyles} />
              </div>

              <h2>
                {language.accountSettings.viewAll.reCaptcha}{' '}
                <Tooltip>
                  <span>
                    Enter your company or business name here, this will
                    represent your business on email addresses.
                  </span>
                </Tooltip>
              </h2>
              <p className={classes.p}>
                <em>
                  {language.accountSettings.viewAll.reduceSpam}{' '}
                  <a
                    href="https://vastreach.com/ReCaptcha"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn More
                  </a>{' '}
                </em>
              </p>
              <div className={classes.p}>
                <TextField
                  variant="outlined"
                  onChange={this.handleChange}
                  name="recaptcha_byo_sitekey"
                  label={language.accountSettings.labels.siteKeyLabel}
                  style={{ margin: 8 }}
                  value={preferences.recaptcha_byo_sitekey}
                  placeholder={
                    language.accountSettings.helperText.siteKeyPlaceHolder
                  }
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  variant="outlined"
                  onChange={this.handleChange}
                  name="recaptcha_byo_secretkey"
                  label={language.accountSettings.labels.secretKeyLabel}
                  style={{ margin: 8 }}
                  value={preferences.recaptcha_byo_secretkey}
                  placeholder={
                    language.accountSettings.helperText.secretKeyPlaceHolder
                  }
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <p className={classes.p}>
                  <em>{language.accountSettings.viewAll.reCaptchaType}</em>
                </p>
                <RadioGroup
                  aria-label="Recaptcha_byo_type"
                  name="recaptcha_byo_type"
                  value={preferences.recaptcha_byo_type}
                  onChange={this.handleChange}
                >
                  <FormControlLabel
                    value="invisible"
                    style={{ margin: 8 }}
                    control={
                      <Radio
                        checked={preferences.recaptcha_byo_type === 'invisible'}
                      />
                    }
                    label={language.accountSettings.labels.reCaptchaInvisible}
                  />
                  <FormControlLabel
                    value="checkbox"
                    style={{ margin: 8 }}
                    control={
                      <Radio
                        checked={preferences.recaptcha_byo_type === 'checkbox'}
                      />
                    }
                    label={language.accountSettings.labels.reCaptchaCheckbox}
                  />
                </RadioGroup>
              </div>
            </Grid>
          </Grid>

          <div>
            <Tooltip2 title={language.accountSettings.toolTips.saveSettings}>
              <Button
                color="secondary"
                variant="fab"
                aria-label="Add task"
                className={classNames(
                  classes.button,
                  classes.floatingActionButton,
                )}
                onClick={this.handleSubmit}
                // disabled={!preferences.default_email_from}
              >
                <DoneIcon />
              </Button>
            </Tooltip2>
          </div>
        </Paper>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withMobileDialog()(AccountSettingsPage)))
